import axios from "axios";
import { validateClinicBranchParams } from "@/utils/routeValidation";

const moduleDebtor = {
  namespaced: true,
  state: {
    debtorList: [],
  },
  mutations: {
    setDebtorList(state, data) {
      state.debtorList = data;
    },
  },
  actions: {
    async fetchDebtorList({ commit }, { clinicUrl, branchUrl }) {
      if (!validateClinicBranchParams(clinicUrl, branchUrl, "fetchDebtorList")) {
        return Promise.reject(new Error("Invalid clinic/branch parameters"));
      }
      try {
        const res = await axios.get(
          `/api/master/debtor/${clinicUrl}/${branchUrl}`,
          { skipGlobalErrorHandler: true }
        );
        const items = Array.isArray(res.data) ? res.data : (res.data.data || []);
        commit("setDebtorList", items);
        return res;
      } catch (err) {
        console.error("fetchDebtorList failed", err);
        throw err;
      }
    },

    fetchDebtorById(_, { clinicUrl, branchUrl, debtorId }) {
      if (!validateClinicBranchParams(clinicUrl, branchUrl, "fetchDebtorById")) {
        return Promise.reject(new Error("Invalid clinic/branch parameters"));
      }
      return axios
        .get(
          `/api/master/debtor/${clinicUrl}/${branchUrl}/${debtorId}`,
          { skipGlobalErrorHandler: true }
        )
        .then(res => res)
        .catch(err => { throw err; });
    },

    createDebtor(_, { clinicUrl, branchUrl, debtorData }) {
      if (!validateClinicBranchParams(clinicUrl, branchUrl, "createDebtor")) {
        return Promise.reject(new Error("Invalid clinic/branch parameters"));
      }
      return axios
        .post(
          `/api/master/debtor/${clinicUrl}/${branchUrl}`,
          debtorData,
          { skipGlobalErrorHandler: true }
        )
        .then(res => res)
        .catch(err => { throw err; });
    },

    updateDebtor(_, { clinicUrl, branchUrl, debtorId, debtorData }) {
      if (!validateClinicBranchParams(clinicUrl, branchUrl, "updateDebtor")) {
        return Promise.reject(new Error("Invalid clinic/branch parameters"));
      }
      return axios
        .put(
          `/api/master/debtor/${clinicUrl}/${branchUrl}/${debtorId}`,
          debtorData,
          { skipGlobalErrorHandler: true }
        )
        .then(res => res)
        .catch(err => { throw err; });
    },

    deleteDebtor(_, { clinicUrl, branchUrl, debtorId }) {
      if (!validateClinicBranchParams(clinicUrl, branchUrl, "deleteDebtor")) {
        return Promise.reject(new Error("Invalid clinic/branch parameters"));
      }
      return axios
        .delete(
          `/api/master/debtor/${clinicUrl}/${branchUrl}/${debtorId}`,
          { skipGlobalErrorHandler: true }
        )
        .then(res => res)
        .catch(err => { throw err; });
    },
  },
  getters: {
    getDebtorList: state => {
      return state.debtorList;
    },
  },
};

export default moduleDebtor;
